export const blue      = '#00338D'
export const orange    = '#FF991A'
export const orange_1  = '#FF701A'
export const videoblue = '#55BEE7'
export const gray      = 'rgb(239,239,239)'
export const darkgray  = 'rgb(221,221,221)'
export const warning   = '#9F6000'
export const green     = 'rgb(34,177,76)'
export const red       = '#C70039'
export const danger    = '#9F6000'
export const lightgray = 'rgb(211,211,211)'
export const darkred = '@ED3E38'
export const black = 'rgb(0,0,0)'


// WEBPACK FOOTER //
// ./src/utils/constants/sitecolors.js